import React from "react";
import NextLink from "next/link";
import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from "@mui/material";

/**
 * Generic Breadcrumb component.
 *
 * Usage:
 * <Breadcrumbs
 *   items={[
 *     { label: "Home", href: "/" },
 *     { label: "Category", href: "/category" },
 *     { label: "Current Page" },
 *   ]}
 * />
 */
export default function Breadcrumbs({ items = [], separator = "/", sx = {} }) {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <MUIBreadcrumbs aria-label="breadcrumb" separator={separator} sx={sx}>
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        if (item.href && !isLast) {
          return (
            <Link
              key={`${item.label}-${idx}`}
              component={NextLink}
              href={item.href}
              underline="hover"
              color="inherit"
            >
              {item.label}
            </Link>
          );
        }
        return (
          <Typography key={`${item.label}-${idx}`} color="text.primary">
            {item.label}
          </Typography>
        );
      })}
    </MUIBreadcrumbs>
  );
}


